import * as React from 'react';
import { cn } from '../../lib/utils.js';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[88px] w-full rounded-md border border-border bg-card px-3.5 py-2.5 text-sm transition-colors',
        'placeholder:text-muted-foreground/70',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background focus-visible:border-transparent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'dark:bg-card-raised dark:border-white/10',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
